<template>
  <v-layout align-center v-if="lastTransaction">
      <v-tooltip nudge-bottom>
        <v-layout slot="activator" align-center v-if="lastTransaction.from_user">
          <v-layout column justify-center>
          <span
            class="subheading mr-1" style="line-height: 0.9">
            {{ shortName(lastTransaction.from_user.name) }}
          </span>
            <span
              class="subtitle grey--text tex--lighten-3" style="line-height: 0.9">
            {{ shortName(lastTransaction.from_user.role.name) }}
          </span>
          </v-layout>
          <v-avatar size="24" color="grey lighten-3">
            <v-img
              v-if="!isEmpty(lastTransaction.from_user.avatar)"
              :src="lastTransaction.from_user.avatar"
            />
            <span v-else>{{ acronym(lastTransaction.from_user.name) }}</span>
          </v-avatar>
        </v-layout>
        <span>{{ (lastTransaction.origin.name) }}</span>
      </v-tooltip>
      <v-icon class="mx-1" color="grey lighten-2">mdi-ray-start-arrow</v-icon>
      <v-tooltip nudge-bottom>
        <v-layout slot="activator" align-center v-if="lastTransaction.to_user">
          <v-avatar class="mr-2" size="24" color="grey lighten-3">
            <v-img
              v-if="!isEmpty(lastTransaction.to_user.avatar)"
              :src="lastTransaction.to_user.avatar"
            />
            <span v-else>{{ acronym(lastTransaction.to_user.name) }}</span>
          </v-avatar>
          <v-layout column justify-center>
          <span
            class="subheading" style="line-height: 0.9">
            {{ shortName(lastTransaction.to_user.name) }}
          </span>
            <span
              class="subtitle grey--text tex--lighten-3" style="line-height: 0.9">
            {{ shortName(lastTransaction.to_user.role.name) }}
          </span>
          </v-layout>
        </v-layout>
        <v-layout v-else slot="activator" align-center>
          <v-avatar class="mr-2" size="24" color="grey lighten-3">
            <span>{{ acronym(lastTransaction.destination.name) }}</span>
          </v-avatar>

        </v-layout>
        <span>
      {{ shortName(lastTransaction.destination.name) }}
    </span>
        <br>
        <span>
      {{lastTransaction.received ? 'Processo Recebido' : 'Aguardando Recebimento'}}
    </span>
      </v-tooltip>
  </v-layout>
  <v-chip v-else>Pasta não tramitada</v-chip>
</template>

<script>

  import { first, isEmpty } from 'lodash';
  import shortName from '@/utils/short-name';
  import acronym from '@/utils/acronym';

  export default {
    name: 'TransactionIndicator',
    props: ['folder'],
    data() {
      return {
        isEmpty,
        shortName,
        acronym,
      };
    },
    computed: {
      lastTransaction() {
        return first(this.folder.transactions);
      },
    },
    methods: {},
  };
</script>

<style scoped>
  .folder-id {
    font-size: 12px;
  }

  .folder-type-border {
    position: absolute;
    height: 100%;
    left: 1px;
    border-radius: 3px 0 0 3px;
    border-left: 5px solid;
    transition: ease-in-out .15s;
  }

  .mdi-folder-open {
    -moz-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  .role {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/TransactionIndicator.vue